import {combineReducers} from 'redux';

import eventScheduleReducer from './event-schedule-slice';
import eventPricingDefaultsReducer from './event-pricing-defaults-slice';
import pastEventsListReducer from './past-events-list-slice';
import dayOverviewReducer from 'pages/event-management/store/day-overview-slice';

const eventsReducer = combineReducers({
    eventSchedule: eventScheduleReducer,
    eventPricingDefaults: eventPricingDefaultsReducer,
    pastEvents: pastEventsListReducer,
    dayOverview: dayOverviewReducer,
});

export default eventsReducer;
